import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePage from "./pages/Home/HomePage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndCondition from "./pages/TermsAndCondition";
import ConsentForm from "./pages/ConsentForm";
import ViewDetail from "./pages/ViewDetail";
import FindLatestNews from "./pages/findLatestNews";
import ViewAllDetail from "./pages/Home/ViewAllDetail";
import FindParkingSlot from "./pages/FindParkingSlot/FIndParkingSlot";
import Filters from "./pages/FindParkingSlot/Filters";
import BookingDetail from "./pages/FindParkingSlot/Booking-detail/BookingDetail";
import Profile from "./pages/Profile/SideNavBar";
import Account from "./pages/Profile/Account/Account";
import Login from "./auth/pages/Login";
import SignUp from "./auth/pages/SignUp";
import ForgetPassword from "./auth/pages/ForgetPassword";
import Finish from "./auth/pages/Finish";
import CreateAccount from "./auth/pages/CreateAccount";
import CreationSuccessfull from "./auth/pages/CreationSuccessful";
import ResetPassword from "./pages/Profile/ResetPassword/ResetPassword";
import Favourite from "./pages/Profile/Favourite/Favourite";
import ContactUs from "./pages/contactUs/ContactUs";
import CancellationPolicy from "./pages/CancellationPolicy";
import Offers from "./pages/Profile/Offers/Offers";
import WalletHistroy from "./pages/Profile/Wallet/WalletHistory";
import Wallet from "./pages/Profile/Wallet/Wallet";
import MyBookings from "./pages/Profile/MyBookings/MyBookings";
import MyBookingDetail from "./pages/Profile/MyBookingDetail/MyBookingDetail";
import Payment from "./pages/Paymentsuccessful/Payment";
import SignIn from "./auth/pages/SignIn";
import OtpAcceptPage from "./auth/pages/OtpAcceptPage";

import MyCars from "./pages/Profile/Vehicle/MyCars";
import AddVehicle from "./pages/Profile/Vehicle/Vehicle";
import PaymentSuccess from "./pages/Paymentsuccessful/PaymentSuccess";
import PaymentCancel from "./pages/Paymentsuccessful/PaymentCancel";
import ExtraPaymentSuccess from "./pages/Paymentsuccessful/ExtraPaymentSuccess";
import Contactsupport from "./pages/Profile/ContactSupport/Contactsupport";
import PageNotFound from "./pages/Errors/PageNotFound";
import TokenExpire from "./pages/Home/TokenExpire";
import FeedBack from "./components/FeedBack/FeedBack";
import Cities from "./pages/Cities/Cities"
import BecomeAPartner from "./pages/BecomeAPartner/BecomeAPartner";

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          {/* Home routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/view-all-detail" element={<ViewAllDetail />} />
          <Route path="/logout" element={<TokenExpire/>} />
          {/* ViewDetail routes */}
          {/* <Route path="/view-detail" element={<ViewDetail />} /> */}
          <Route path="/find-blog" element={<FindLatestNews />} />
          <Route path="/cities" element={<Cities/>} />
          <Route path="/become-a-partner" element={<BecomeAPartner/>} />
          {/* PartnerWithSpotFinder  routes */}
          <Route path="/terms-and-condition" element={<TermsAndCondition />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/feed-back" element={<FeedBack />} />
          {/* Auth Routes */}
          <Route path="/profile/auth/login" element={<Login />} />
          <Route path="/profile/auth/SignIn" element={<SignIn />} />
          <Route path="/profile/auth/signUp" element={<SignUp />} />
          <Route path="/profile/auth/finish" element={<Finish />} />
          <Route
            path="/profile/auth/forget-password"
            element={<ForgetPassword />}
          />
          <Route
            path="/profile/auth/OtpAcceptPage"
            element={<OtpAcceptPage />}
          />
          <Route
            path="/profile/auth/create-account"
            element={<CreateAccount />}
          />
          <Route
            path="/profile/auth/creation-success"
            element={<CreationSuccessfull />}
          />
          {/* Profile routes */}
          <Route path="/profile" element={<Profile />}>
            <Route index element={<Account />} />
            <Route path="find-vehicle" element={<FindParkingSlot />} />
            <Route
              path="cancellation-policy"
              element={<CancellationPolicy />}
            />
            <Route path="account" element={<Account />} />
            <Route path="offers" element={<Offers />} />
            <Route path="/profile/vehicle" element={<MyCars />} />
            <Route
              path="/profile/contact-support"
              element={<Contactsupport />}
            />
            <Route path="/profile/vehicle/myvehicle" element={<AddVehicle />} />
            <Route path="reset-password" element={<ResetPassword />} />
            <Route path="terms-and-condition" element={<TermsAndCondition />} />
            <Route path="favourites" element={<Favourite />} />
            <Route path="/profile/Wallet-histroy" element={<WalletHistroy />} />
            <Route path="booking" element={<MyBookings />} />
            <Route path="my-booking-detail" element={<MyBookingDetail />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/profile/payment" element={<Payment />} />
            <Route path="/profile/payment/:orderId" element={<Payment />} />
            <Route path="/profile/Booking-detail" element={<BookingDetail />} />
            <Route path="*" element={<PageNotFound />} />
          </Route>
          {/* Parking routes */}
          <Route path="/Payment-successs" element={<PaymentSuccess />} />

          <Route
            path="/extra-Payment-successs"
            element={<ExtraPaymentSuccess />}
          />
          <Route path="/Payment-cancel" element={<PaymentCancel />} />
          <Route path="*" element={<PageNotFound />} />
          <Route path="/booking-detail-slot" element={<BookingDetail />} />
          <Route path="/filters" element={<Filters />} />
          {/* error handlers */}
          {/* Components playground */}
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
